import BudgetTab from "./BudgetTab";

export default function AccountingManagementTab() {
  return <BudgetTab moduleMode="accounting" />;
}
